import React, { FC, useState } from 'react'

// Components
import ConfirmationCompsWrapper from './ConfirmationCompsWrapper'
import { AmountByPerson } from './AmountByPerson'
import { Separator } from '../../../../../../components/ui/separator'

import { getFloatPrice } from '../../../../../../helpers/price'

import { useAppSelector } from '../../../../../../store/hooks'
import { selectPayTabGrandTotalAccordion } from '../../../../../../store/registration/registrationSlice'

interface SelectedEventGrandTotalProps {
  isSplitBill: boolean
  currency: string
}

const SelectedEventGrandTotal: FC<SelectedEventGrandTotalProps> = ({ isSplitBill, currency }) => {
  const grandTotal = useAppSelector(selectPayTabGrandTotalAccordion)

  const [open, setOpen] = useState(true)

  return (
    <ConfirmationCompsWrapper
      title="Order Summary"
      accordion={{ open, setOpen }}
      disableEditBtn={true}
      grandTotal={getFloatPrice(`${currency}${grandTotal?.totalPrice}`)}
      showList={!!grandTotal?.totalItemsCount}
    >
      <div className="space-y-3 p-4">
        {isSplitBill && (
          <>
            <div className="space-y-3">
              <h4 className="font-medium text-gray-900">Amount by Person:</h4>
              {grandTotal.amountByPerson.map((person) => (
                <AmountByPerson
                  key={person.recipientName}
                  name={person.recipientName || ''}
                  assigned={person.assigned}
                  billed={person.billed}
                  total={getFloatPrice(`${currency}${person.amountToPay}`)}
                />
              ))}
            </div>
            <Separator />
          </>
        )}

        <div className="flex flex-wrap gap-2 items-center justify-between w-full">
          <p className="text-gray-700">Registrations</p>
          <p className="font-medium text-right">
            {getFloatPrice(`${currency}${grandTotal?.registrationTotal}`)}
          </p>
        </div>

        <div className="flex flex-wrap gap-2 items-center justify-between w-full">
          <p className="text-gray-700">Fees</p>
          <p className="font-medium text-right">
            {getFloatPrice(`${currency}${grandTotal?.feesTotal}`)}
          </p>
        </div>

        <div className="flex flex-wrap gap-2 items-center justify-between w-full">
          <p className="text-gray-700">Mandatory Fees</p>
          <p className="font-medium text-right">
            {getFloatPrice(`${currency}${grandTotal?.governanceTotal}`)}
          </p>
        </div>

        <div className="flex flex-wrap gap-2 items-center justify-between w-full">
          <p className="text-gray-700">Tickets</p>
          <p className="font-medium text-right">
            {getFloatPrice(`${currency}${grandTotal?.ticketTotal}`)}
          </p>
        </div>

        <div className="flex flex-wrap gap-2 items-center justify-between w-full">
          <p className="text-gray-700">Sales Tax</p>
          <p className="font-medium text-right">
            {getFloatPrice(`${currency}${grandTotal?.salesTax}`)}
          </p>
        </div>

        <div className="pt-4 md:pt-6 flex flex-wrap gap-2 items-center justify-between w-full border-t border-gray-100">
          <p className="text-lg font-bold">Grand total</p>
          <p className="text-lg font-bold text-right">
            {getFloatPrice(`${currency}${grandTotal?.totalPrice}`)}
          </p>
        </div>
      </div>
    </ConfirmationCompsWrapper>
  )
}

export default SelectedEventGrandTotal
